import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f326870"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-item"
}
const _hoisted_2 = { class: "value" }
const _hoisted_3 = { class: "base-info van-hairline--bottom" }

import { withDefaults, computed } from 'vue'
import { OrderInvoiceApplyInfo } from '@/types/invoice'


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-base-info',
  props: {
    item: { default: () => null }
  },
  setup(__props: any) {

const props = __props as { item: OrderInvoiceApplyInfo };


// 发票税号显示文案
const taxpayerNo = computed(() => {
  if (props?.item?.bill_type === 1 || !props?.item?.taxpayer_no) {
    return '-'
  }
  return props.item.taxpayer_no
})
// 获取标签文案
function getTagText(type: number) {
  return type === 0 ? '普票' : '专票'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["tag", props.item.invoice_type === 0 ? 'normal-tag' : 'special-tag'])
          }, _toDisplayString(getTagText(props.item.invoice_type)), 3),
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.item.header), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, "发票税号：" + _toDisplayString(_unref(taxpayerNo)), 1),
      _createElementVNode("li", null, "短信通知：" + _toDisplayString(props.item.phone || props.item.company_phone || '-'), 1)
    ])
  ], 64))
}
}

})